import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "revenue-content"
};
const __default__ = {
  name: 'RevenueKanbanManageNew'
};
import RevenueHeader from '@/views/revenueKanbanManageNew/components/RevenueHeader.vue';
import EchartsContent from '@/views/revenueKanbanManageNew/components/EchartsContent.vue';
import TableContent from '@/views/revenueKanbanManageNew/components/TableContent.vue';
// 组件引用，用于调用子组件方法
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    // 引入子组件
    const echartRef = ref(null),
      tableRef = ref(null);
    // 搜索回调函数：当头部搜索条件变化时，更新图表和表格数据
    const returnSearch = obj => {
      var _echartRef$value, _tableRef$value;
      (_echartRef$value = echartRef.value) === null || _echartRef$value === void 0 || _echartRef$value.getData(obj);
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(RevenueHeader, {
        onReturnSearch: returnSearch
      }), _createVNode(EchartsContent, {
        ref_key: "echartRef",
        ref: echartRef
      }, null, 512), _createVNode(TableContent, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});